import React from "react";
import { BaseDrawer } from "./base";

interface VilleDrawerProps {
  ville: any;
  onClose: () => void;
}

export function VilleDrawer({ ville, onClose }: VilleDrawerProps) {
  return <BaseDrawer entity={ville} entityType="ville" onClose={onClose} />;
}
